import { ReactElement } from 'react';
import BasicLayout from '../layouts/BasicLayout';
import { Outlet } from 'react-router-dom';
import MobileLandingPage from './views/MobileLandingPage';

const MobileLandingRoute = (props:any): ReactElement => {
  const data=props.loginData;
  const permissions = props.permissions;

 return (
    <BasicLayout userData={data} permissions={permissions} sidebars={props.sidebarsData}>
      <MobileLandingPage/>
      <Outlet />
    </BasicLayout>
  )
};

export default MobileLandingRoute;